var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1177_288",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1177_288",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC80lEQVR4nO2ZSWgVQRCGPyMhcQlxhZCABw+ioHgRvLqcBBEUBcEFcnEBUQ9RQRMRMSc1B0+ihOSgCKKCSlBE0GiU4HJQIZDgBiIuEXfFbLY0VOA5zMtUz/bmMD/U6b3+ez6mp7q6GnLlypWmpgFrgP3AGaALeCTRCVwAmoF1QA0Z02RgO3ATGAKMMkaAbmA3UF1KgGqgEfjk8PDF4gdwFJiSNsQq4EMMAN7oBzanATARaE0AwBvngKqkIOxrv5sChJF4CtTGDVEjxibl6ANmxgVRIdnFlCgeyJKOrDS+Cc03E0nrMwBhJNaGhZgEvMkAgJF4L5WDs44oJ7BJYCuwTcqQJGGaXSEmAF8Uxo/lzY2qDhhMEOSz6/6ySWH6F5jvM/Z8wm9lpwvIbYXhrSJjlyQM0ulSDA4rDFvG8HiWIMgwMEMDslJp2DSGx+EspOIDSrP2IuPLZDdOEqRJA9LmUAeN8xl/LGEII6fPQF13MFzuGVuXAoQZI9H8J5dS/SEw3jP+bAogXRqQe46muzzjpwOvEwbp1oB0OJr+AuZ6PBbKLlzSpdUWwrjHpxOyCHhX5P/fgRPAq5Ag7RqQfSHNO3y+l1ppE3nbQLZ5YVUuzYYex7kOaUBWRHjlrbKPeGUbck/kPwd9fi+Txt7zODdE23AbiJjj7fHYK7vnzA6Ye6/Cf0QSiko3YkiPs3DXSeXRQa2NEUFsfJNWqv0ONKoEXip8bV/Z6WDVHwOMkcy0I6BirZQGgwmI39rKt1ANMYGMxqBkNnskXgBMleVXD/QqPU4TQmnVTdr4qUgWvtqQgYc3BWGvH0JJs2bTivs+m61K5couShrxIsrt1rIMABjgIzCHCGrJAESvT1XtrL4SQ1yL4xpuXomX0pYihaez9gRMZg9MF6X8sP99GwPA1yQuQ694JhmQE5ltEy32SYMV0mK9CvxxePgh6Q/Ux3WR49VqaUsel7NJYZM6SFXSWWmQk+Zl4I74XQJOSdG31NE3V65cRNM/YCDv/PbBtugAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.b9cb62d4467625e19e5197bbbe86ae24.svg";
export { ForwardRef as ReactComponent };